import { createContext, useContext } from "react";

/**
 * Selects a swimlane row by span ID. The provider maps the ID to the
 * correct (name, spanIndex) pair needed by the timeline state.
 */
export type TimelineSelectByIdFn = (spanId: string) => void;

export const TimelineSelectContext = createContext<TimelineSelectByIdFn | null>(
  null
);

export function useTimelineSelect(): TimelineSelectByIdFn | null {
  return useContext(TimelineSelectContext);
}

/** Selects a swimlane row by its row key. Passing `anchorEl` (the clicked
 *  inline element) lets the host scroll-anchor so it stays at the same
 *  viewport position after the selection change re-renders the list. */
export type TimelineSelectRowFn = (
  rowKey: string,
  anchorEl?: HTMLElement
) => void;

export const TimelineRowSelectContext =
  createContext<TimelineSelectRowFn | null>(null);

export function useTimelineRowSelect(): TimelineSelectRowFn | null {
  return useContext(TimelineRowSelectContext);
}
